
import isReachable from 'is-reachable';
//import isOnline from 'is-online';


export default async function CheckVPN(): Promise<boolean> {
    // console.log("Ejecutando CheckVPN");

    let Resultado: boolean = true;

    let host = 'jenkins.starken.cl';

    Resultado = await isReachable(host);

    // console.log("Resultado: " + Resultado);


    return Resultado;
}